import {createAction, props} from '@ngrx/store';
import {EkranBrakuPrezentacjiKwotyPoKalkulacji} from './ekran-braku-prezentacji-kwoty-po-kalkulacji';
import {Samoobsluga} from '../../../../shared/services/samoobsluga/types/samoobsluga';

export const ustawStanKwotaUkryta = createAction(
  EkranBrakuPrezentacjiKwotyPoKalkulacji.USTAW_STAN_KWOTA_UKRYTA,
  props<{ correlationId: string , stanSamoobslugi: string }>()
);

export const wyslijStanKwotaUkryta = createAction(EkranBrakuPrezentacjiKwotyPoKalkulacji.WYSLIJ_STAN_KWOTA_UKRYTA);

export const zapiszStorePoZmianieStanuNaKwotaUkryta = createAction(EkranBrakuPrezentacjiKwotyPoKalkulacji.ZAPISZ_STORE_PO_ZMIANIE_STANU_NA_KWOTA_UKRYTA, props<Samoobsluga>());
export const ustawStanKwotaUkrytaSuccess = createAction(EkranBrakuPrezentacjiKwotyPoKalkulacji.USTAW_STAN_KWOTA_UKRYTA_SUCCESS);
